import { AdminPage } from "./pages/AdminPage";
import { AboutPage } from "./pages/AboutPage";
import { MadonnaCardsPage } from "./pages/MadonnaCardsPage";
import { StatusPage } from "./pages/StatusPage";
import { SubmitPage } from "./pages/SubmitPage";
import { TermsPage } from "./pages/TermsPage";
import { WallPage } from "./pages/WallPage";

export function App() {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  const status = path.match(/^\/status\/([a-f0-9]{48})$/);
  const wall = path.match(/^\/(?:screen|wall)\/(east|south|west|north|ceiling|[1-5])$/);

  if (path === "/admin") return <AdminPage />;
  if (path === "/all-cards-for-madonna") return <MadonnaCardsPage />;
  if (path === "/all-cards-report") return <MadonnaCardsPage report />;
  if (path === "/about" || path === "/about-the-project") return <AboutPage />;
  if (path === "/terms" || path === "/terms-and-conditions") return <TermsPage />;
  if (status) return <StatusPage token={status[1]} />;
  if (wall) return <WallPage screenId={wall[1]} />;
  return <SubmitPage />;
}
